<!--
 * @Author: M.D.
 * @Date: 2020-01-16 15:50:44
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="pr-o-w">
    <div class="pr-i-w">
      <div class="pr-res-info">
        <div class="pr-ri-l">
          <img src="@/assets/image/sub_ord-sucs.png" alt="">
        </div>
        <div class="pr-ri-r">
          <div class="pr-rir-u">
            {{ subOrderType === 1 ? '订单已提交！' : '兑换成功！' }}
          </div>
          <div class="pr-rir-d">
            {{exChgRe.msg}}
            <!-- 我们将在24小时内电话联系您，请耐心等待~ -->
          </div>
        </div>
      </div>
      <div class="handle-btn">
        <el-button v-if="(exChgRe && !exChgRe.isOnPay)" style="width:34%" class="pr-i-btn" type="primary" @click="goMyPoint">我的积分</el-button>
        <!-- <el-button style="width:34%" class="pr-i-btn" type="primary" v-else-if="showQrcode" @click="showQrCode">查看二维码</el-button> -->
        <el-link class="pr-i-to-btn" @click="toOrdDetail" :underline="false" type="info">我的订单 >></el-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {
      // 非在线提交结果
      exChgRe: '',
      subOrderType: 1,
      qr: ''
    }
  },
  computed: {
    showQrcode () {
      return this.qr !== ''
    }
  },
  created () {
    this.exChgRe = this.$route.params.exChgRe
    this.subOrderType = this.$route.params.type
    this.qr = this.$route.query.qr
  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    toOrdDetail () {
      this.$router.push({ path: `/orderDetail/${this.$route.query.orderId}` })
      // this.$router.push({
      //   name: 'orderDetail',
      //   query: {
      //     orderNumber: this.$route.query.orderNumber
      //   }
      // })
    },
    showQrCode () {
      const orderNumber = this.$route.query.orderNumber
      this.$router.push({
        name: 'payQRCode',
        query: {
          orderNumber
        }
      })
    },
    // 我的积分
    goMyPoint () {
      this.$router.push({
        name: 'mypoint'
      })
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.pr-o-w
  min-height 600px
  background-color #ffffff
  center()
  .pr-res-info
    display flex
    .pr-ri-l
      flex 0 0 100px
      margin-right 30px
      img
        display inline-block
        width 100%
    .pr-ri-r
      flex 1 1 auto
      .pr-rir-u
        height 52px
        line-height 52px
        font-size 22px
        color theme-color
      .pr-rir-d
        font-size 18px
        color #808080
  .handle-btn
    margin 40px 0
    flex-ltr-parent()
    .pr-i-btn
      font-size 20px
    .pr-i-to-btn
      font-size 20px
      width 160px
</style>
